import * as React from "react";
import { cn } from "@app/lib/utils";

export const inputPrimitiveVariants = {
  success:
    "border-success bg-card text-foreground placeholder:text-success/70 focus-visible:border-success focus-visible:ring-success/20",
  danger:
    "border-destructive bg-card text-destructive placeholder:text-destructive/70 focus-visible:border-destructive focus-visible:ring-destructive/20",
  disabled: "cursor-not-allowed bg-muted text-muted-foreground opacity-70",
  default:
    "border-input bg-card text-foreground placeholder:text-muted-foreground focus-visible:border-primary focus-visible:ring-ring/20",
};

export function getInputPrimitiveClassName(
  variant: keyof typeof inputPrimitiveVariants = "default",
  className?: string,
) {
  return cn(
    "flex h-11 min-h-11 w-full rounded-md border px-4 py-2 text-start text-sm font-medium leading-6 shadow-none transition-all duration-150 ease-in-out placeholder:text-start placeholder:text-sm placeholder:font-normal placeholder:text-muted-foreground/80 focus-visible:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-70",
    inputPrimitiveVariants[variant],
    className,
  );
}

export interface InputPrimitiveProps extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: keyof typeof inputPrimitiveVariants;
}

export const InputPrimitive = React.forwardRef<
  HTMLInputElement,
  InputPrimitiveProps
>(({ className, type, variant, ...props }, ref) => (
  <input
    type={type}
    className={getInputPrimitiveClassName(variant, className)}
    ref={ref}
    {...props}
  />
));

InputPrimitive.displayName = "InputPrimitive";
